<template>
  <video controls="controls" width="560px" height="320px" :src="src"></video>
</template>

<script>
import { VUE_APP_API_PATH } from "@/store/constant";

export default {
  name: "VVideo",
  props: {
    attachmentId: {
      type: String,
      default: "",
    },
  },
  computed: {
    src() {
      if (!this.attachmentId) {
        return null;
      }
      return `${VUE_APP_API_PATH}/file/${this.attachmentId}/download`;
    },
  },
};
</script>

<style scoped></style>
